<template>
  <div>
    <DxForm id="formularioTipoDocumentoOperacion" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" :visible="model != null" validation-group="validacionTipoDocumentoOperacion">
      <!-- xs: 768, sm: 992, md:1200 -->
      <DxColCountByScreen :xs="4" :sm="4" :md="4" :lg="4" />

      <DxGroupItem :col-span="4" :col-count="4">
        <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('tipo_documento_operacion.form.nombre')" />
          <DxRequiredRule :message="$t('tipo_documento_operacion.form.validacion.nombre')" />
          <DxStringLengthRule :message="$t('tipo_documento_operacion.form.validacion.nombre_longitud')" :min="1" :max="90" />
        </DxSimpleItem>
        <DxSimpleItem data-field="AplicaPersonaFisica" :col-span="2">
          <DxCheckBox v-model="props.model!.AplicaPersonaFisica" :text="$t('tipo_documento_operacion.form.aplica_persona_fisica')  "/>
          <DxLabel :visible="false" />
        </DxSimpleItem>
        <DxSimpleItem data-field="AplicaPersonaJuridica" :col-span="2">
          <DxCheckBox v-model="props.model!.AplicaPersonaJuridica" :text="$t('tipo_documento_operacion.form.aplica_persona_juridica')" />
          <DxLabel :visible="false" />
        </DxSimpleItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { messageBoxResult } from '@components/dialogs/message-box';
import { type CreateTipoDocumentoEmpresaServiciosModel, type DetailTipoDocumentoEmpresaServiciosModel, type EditTipoDocumentoEmpresaServiciosModel, } from '@api/api';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { type DxButton } from 'devextreme-vue';
import {
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import { DxCheckBox } from "devextreme-vue";
import { getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from 'vue';
import { useIntl } from '@services/i18n';
import validationEngine from "devextreme/ui/validation_engine";
import { useApi } from '@api/integration';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { DxStringLengthRule } from 'devextreme-vue/cjs/validator';

const api = useApi();
const formInstance = ref<DxForm>();
const intl = useIntl();
const props = defineProps({
  model: {
    type: Object as () => DetailTipoDocumentoEmpresaServiciosModel |  CreateTipoDocumentoEmpresaServiciosModel,
    required: true
  },
  isEditMode: {
    type: Boolean,
    required: true
  }
});

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    saveOrEdit().then((value) => {
      if (value)
        modal.close(messageBoxResult.ok)
    });
  }
  );
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}

const saveOrEdit = async () => {
  var resValidation = validationEngine.validateGroup("validacionTipoDocumentoOperacion");

  if (resValidation.isValid) {
    if (props.isEditMode) {
      await api.callStandardApi("editTipoDocumentoEmpresaServicios", { showLoading: true }, props.model as EditTipoDocumentoEmpresaServiciosModel)
        .then(() => toastSuccess(intl.i18n.t('tipo_documento_operacion.edicion_exito')))
        .catch(() => {
          toastError(intl.i18n.t('tipo_documento_operacion.edicion_fallo'));
          return false;
        });
    } else {
      await api.callStandardApi("createTipoDocumentoEmpresaServicios", { showLoading: true }, props.model as CreateTipoDocumentoEmpresaServiciosModel)
        .then(() => toastSuccess(intl.i18n.t('tipo_documento_operacion.creacion_exito')))
        .catch(() => {
          toastError(intl.i18n.t('tipo_documento_operacion.creacion_fallo'));
          return false;
        });
    }
    return true;
  } else {
    toastError(intl.i18n.t('tipo_documento_operacion.revise_validacion'));
  }

  return false;
}

</script>
<style lang="scss" scoped></style>
